import useNewThumbnailsEnabled from '~/client/hooks/feature/useNewThumbnailsEnabled';
import useAgentData from '~/client/hooks/useAgentData';
import placeholderItems from '~/client/shared/LazyLoad/Placeholder/helpers/placeholderItems';
import GamesContainer from '../GamesContainer';

type Props = { width: number; height: number; isGridVisible?: boolean };

const GameListPlaceholder: FC<Props> = ({ isGridVisible, height, width }) => {
  const newThumbsEnabled = useNewThumbnailsEnabled();
  const { isDesktop } = useAgentData();
  const placeholder = placeholderItems({
    length: isDesktop ? 30 : 12,
    width,
    height,
    showGameInfo: !newThumbsEnabled,
  });
  return (
    <GamesContainer width={width} isGridVisible={isGridVisible}>
      {placeholder}
    </GamesContainer>
  );
};

export default GameListPlaceholder;
